import React, { useState, useEffect } from "react";
import Ruppes from "./ruppes.svg";
import l from "./L.svg";
import box from "./box.svg";
import down from "./down.svg";
import "./YellowpostDashboard.css";
import GreenUp from "./GreenUp.svg";
import greenL from "./greenL.svg";
import GraphComponent from "./GraphComponent";
import TotalBooking from "./TotalBooking.svg";
import TotalProposel from "./TotalProposel.svg";
import { changeIndex } from "../../../toolkit/slices/cart/cartSlice";
import {
  Space,
  Table,
  Tag,
  Switch,
  Select,
  Input,
  AutoComplete,
  Menu,
} from "antd";
import { Tabs, Modal, DatePicker, Button, Dropdown } from "antd";
import MonthlyCategoryChart from "./GraphComponent";
import { Collapse } from "antd";
import { render } from "@testing-library/react";
import AuthorizationError from "../AuthorizationError";
import accessCheckPromise from "../../../../utils/accessCheck";
import { useDispatch } from "react-redux";
import BarChartComponent from "./SalesGraphComponent";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import moment from "moment";
import { FaPencilAlt, FaFilter } from "react-icons/fa";
import { IoIosRefresh } from "react-icons/io";
import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import { useSelector } from "react-redux";
import { MdOutlineDone } from "react-icons/md";
import formatIndianNumber from "../../../../utils/formatIndianNumber";
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const onChange = (checked, key, value) => {
  console.log(`switch to ${checked}`);
  console.log(key);
  console.log(`selected ${value}`);
};
const onSearch = (value) => {
  console.log("search:", value);
};
const { Option } = Select;

const Analysis = () => {
  const [switchStates, setSwitchStates] = useState({
    1: false, // Initialize switch state for Tab 1
    2: false, // Initialize switch state for Tab 2 if needed
    3: false, // Initialize switch state for Tab 3 if needed
  });
  const [firstSelectValue, setFirstSelectValue] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedEmployeeRowData, setSelectedEmployeeRowData] = useState(null);
  const [isEmployeeModalVisible, setIsEmployeeModalVisible] = useState(false);
  const [totalSales, setTotalSales] = useState({});
  const [profit, setProfit] = useState({});
  const [proposals, setProposals] = useState({});
  const [bookings, setBookings] = useState({});
  const [modalTitle, setModalTitle] = useState("");
  const [location, setLocation] = useState("");
  const [topClient, setTopClient] = useState("");
  const [occupancy, setoccupancy] = useState("");
  const [occupancyData, setOccupancyData] = useState([]);
  const [avgDuration, setAvgDuration] = useState("");
  const [isCommonModalVisible, setIsCommonModalVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [access, setAccess] = useState(false);
  const [dates, setDates] = useState([]);
  const tabIndex = useSelector((state) => state.cartSpace.tabIndex);
  // const [employeedata, setEmployeeData] = useState(null);
  const [isModalVisibleEmployee, setIsModalVisibleEmployee] = useState(false);
  const [repeatedClients, setRepeatedClients] = useState([]);
  const [filteredSalesData, setFilteredSalesData] = useState(salesData);
  const [searchValue, setSearchValue] = useState("");
  const [searchOptions, setSearchOptions] = useState([]);
  const [newData, setNewData] = useState([]);
  const [clientData, setClientData] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [segments, setSegments] = useState([]);
  const [selectedoccupancydates, setSelectedOccupancyDates] = useState([]);
  const [activeTab, setActiveTab] = useState("0");
  const [dateRangeString, setDateRangeString] = useState("");
  const dispatch = useDispatch();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    dispatch(changeIndex(1));
  }, []);
  const onChange = (tabKey, checked) => {
    setSwitchStates((prevState) => ({
      ...prevState,
      [tabKey]: checked,
    }));
  };
  // console.log("💕💕💕💕", tabIndex)
  useEffect(() => {
    // Update the active tab when tabIndex changes
    setActiveTab(tabIndex?.toString());
  }, [tabIndex]);

  const handleTabChange = (key) => {
    // Update the active tab when the user changes it
    setActiveTab(key);
    dispatch(changeIndex(key));
  };

  const handleDateChange = (dates) => {
    setDates(dates);
  };
  const fetchData = (start_date, end_date) => {
    console.log("Fetching data for dates:", start_date, end_date);
    fetch(
      `${apiBaseUrl}/analysisApi/get_employee_data?start_date=${start_date}&end_date=${end_date}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ start_date, end_date }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("EmployeesData", data);
        setSalesData(data);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };
  const fetchDataClients = async (start_date, end_date) => {
    const url = `${apiBaseUrl}/analysisApi/get_client_data?start_date=${start_date}&end_date=${end_date}`;

    try {
      const response = await fetch(url, {
        method: "POST", // specify the method
        headers: {
          "Content-Type": "application/json", // specify the content type
        },
        credentials: "include",
        body: JSON.stringify({ start_date, end_date }), // send the data as a string
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json(); // parse the response as JSON
      result.forEach((item) => {
        console.log(`Data for ${item.partyName}:`, item);
      });
      setClientData(result); // set the data in the state
    } catch (error) {
      console.error("There was an error fetching the data:", error);
    }
  };

  useEffect(() => {
    const lastYearStart = moment().subtract(1, "years").startOf("year");
    const lastYearEnd = moment().subtract(1, "years").endOf("year");
    setDates([lastYearStart, lastYearEnd]);
    fetchData(
      lastYearStart.format("YYYY-MM-DD"),
      lastYearEnd.format("YYYY-MM-DD")
    );
    fetchDataClients(
      lastYearStart.format("YYYY-MM-DD"),
      lastYearEnd.format("YYYY-MM-DD")
    );
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
    dispatch(setSideTab(window.location.pathname));
  }, []);
  useEffect(() => {
    if (dates?.length === 2) {
      const start_date = dates[0].format("YYYY-MM-DD");
      const end_date = dates[1].format("YYYY-MM-DD");
      fetchData(start_date, end_date);
      fetchDataClients(start_date, end_date);
    }
  }, [dates]);

  const showRepeatedClients = (clients) => {
    if (Array.isArray(clients)) {
      setRepeatedClients(clients);
    } else {
      setRepeatedClients([]);
    }
    setIsModalVisibleEmployee(true);
  };
  const handleRefresh = () => {
    // Reset states to their default values
    setSelectedSegment(null);
    setClientData([]); // or any default value you want
    setRepeatedClients([]);
    setDates([
      moment().subtract(1, "years").startOf("year"),
      moment().subtract(1, "years").endOf("year"),
    ]);

    // Fetch data with the default date range
    const lastYearStart = moment()
      .subtract(1, "years")
      .startOf("year")
      .format("YYYY-MM-DD");
    const lastYearEnd = moment()
      .subtract(1, "years")
      .endOf("year")
      .format("YYYY-MM-DD");
    fetchData(lastYearStart, lastYearEnd);
    fetchDataClients(lastYearStart, lastYearEnd);
  };

  const handleCancel = () => {
    setIsModalVisibleEmployee(false);
    setIsModalVisible(false);
    setIsCommonModalVisible(false);
  };

  const handleFirstSelectChange = (value) => {
    setFirstSelectValue(value);
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(`https://za3u1gs11d.execute-api.ap-south-1.amazonaws.com/api/get_location_data?year=${selectedYear}`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       });

  //       if (!response.ok) {
  //         throw new Error('Network response was not ok');
  //       }

  //       const result = await response.json();
  //       setNewData(result);
  //       console.log("result", result);
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };

  //   fetchData();
  // }, [selectedYear]); // Re-run the effect when selectedYear changes

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };
  const disableFutureDates = (current) => {
    // Disable dates after today
    return current && current > moment().endOf("day");
  };
  async function onSelectChange(value) {
    // Assuming selectedoccupancydates is defined and available in this scope
    const [startDate, endDate] = selectedoccupancydates || [];

    // Check if both dates are defined
    if (!startDate || !endDate) {
      console.error("Start date or end date is missing.");
      return;
    }

    console.log(
      "startDate",
      startDate.format("YYYY-MM-DD"),
      "endDate",
      endDate.format("YYYY-MM-DD"),
      "segment value",
      value
    );

    // Function to fetch occupancy data
    const fetchOccupancyData = async (startDate, endDate, segmentValue) => {
      const url = `${apiBaseUrl}/analysisApi/get_occupancy_data`;

      const requestData = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        segments: segmentValue,
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Fetched data:", data);

        // Assuming `setOccupancyData` is a function that sets the state
        setOccupancyData(data);

        if (Array.isArray(data)) {
          // Process data if needed
          const segments = data.map((item) => item.segment);
          // Remove duplicates or any other logic you need
        } else {
          console.log("Expected array of objects, but got:", data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Fetch occupancy data
    await fetchOccupancyData(startDate, endDate, value);
  }

  const fetchOccupancyData = async (startDate, endDate) => {
    const url = `${apiBaseUrl}/analysisApi/get_occupancy_data`;

    const requestData = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched data:", data);
      setOccupancyData(data);

      if (Array.isArray(data)) {
        // Assuming each item in the data array has a 'segment' field
        const segments = data.map((item) => item.segment);
        setSegments([...new Set(segments)]); // Remove duplicates if needed
      } else {
        console.log("Expected array of objects, but got:", data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedoccupancydates?.length === 2) {
      const [startDate, endDate] = selectedoccupancydates;
      fetchOccupancyData(
        startDate.format("YYYY-MM-DD"),
        endDate.format("YYYY-MM-DD")
      );
    }
  }, [selectedoccupancydates]);
  useEffect(() => {
    fetchOccupancyData("2023-01-01", "2023-12-31");
  }, []);
  const handleOccupancyDateChange = (dates) => {
    setSelectedOccupancyDates(dates);

    if (dates && dates.length === 2) {
      const startDate = dates[0];
      const endDate = dates[1];

      // Calculate the difference in days
      const daysCount = endDate.diff(startDate, "day");

      const startDateFormatted = startDate.format("YYYY-MM-DD");
      const endDateFormatted = endDate.format("YYYY-MM-DD");

      setDateRangeString(daysCount);

      console.log(`Number of days selected: ${daysCount}`); // You can use this count as needed
    } else {
      setDateRangeString(""); // Reset if no dates are selected
    }
  };

  // useEffect(() => {

  //   // Fetch or generate your data here
  //   const rawData = [
  //     // Example data structure
  //     { category: 'Automobiles', values: [20, 15, 10, 5, 25, 30, 20, 15, 10, 5, 25, 30] },
  //     { category: 'BFSI', values: [10, 20, 30, 40, 10, 20, 30, 40, 10, 20, 30, 40] },
  //     // Add more categories as needed
  //   ];

  //   // Process data to find the most popular category for each month
  //   const processedData = rawData.map((category) => ({
  //     category: category.category,
  //     values: category.values,
  //   }));

  //   setData(processedData);
  //   accessCheckPromise().then(res => setAccess(res))

  // }, []);

  useEffect(() => {
    const salesUrl = `${apiBaseUrl}/analysisApi/get_sales`;
    const profitUrl = `${apiBaseUrl}/analysisApi/get_profit`;
    const proposalsUrl = `${apiBaseUrl}/analysisApi/get_proposals`;
    const bookingsUrl = `${apiBaseUrl}/analysisApi/get_bookings`;
    const fetchOptions = { credentials: "include" };

    Promise.all([
      fetch(salesUrl, fetchOptions).then((response) => response.json()),
      fetch(profitUrl, fetchOptions).then((response) => response.json()),
      fetch(proposalsUrl, fetchOptions).then((response) => response.json()),
      fetch(bookingsUrl, fetchOptions).then((response) => response.json()),
    ])
      .then(([salesData, profitData, proposalsData, bookingsData]) => {
        setTotalSales(salesData);
        setProfit(profitData);
        setProposals(proposalsData);
        setBookings(bookingsData);
        console.log("setAllSales", salesData);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleContainerClick = (type) => {
    let data = {};

    switch (type) {
      case "sales":
        data = {
          new_sales: totalSales.new_sales || "N/A",
          old_sales: totalSales.old_sales || "N/A",
          total_sales: totalSales.total_sales || "N/A",
        };
        break;
      case "profit":
        data = {
          new_profit: profit.new_profit || "N/A",
          old_profit: profit.old_profit || "N/A",
          total_profit: profit.total_profit || "N/A",
        };
        break;
      case "proposals":
        data = {
          accepted_proposals: proposals.accepted_proposals || "N/A",
          pending_proposals: proposals.pending_proposals || "N/A",
          total_proposals: proposals.total_proposals || "N/A",
        };
        break;
      case "bookings":
        data = {
          converted_booking: bookings.converted_booking || "N/A",
          direct_booking: bookings.direct_booking || "N/A",
          total_bookings: bookings.total_bookings || "N/A",
        };
        break;
      default:
        break;
    }
    console.log("Data to be shown in modal:", data);
    commonShowModal(data);
  };

  const commonShowModal = (data) => {
    setModalData(data);
    console.log("setModalData", data);
    setIsCommonModalVisible(true);
  };

  //---------------- location table code

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedRowData(null);
  };
  const handleEmployeeRowClick = (record) => {
    setSelectedEmployeeRowData(record);
    setIsEmployeeModalVisible(true);
  };

  const handleCloseEmployeeModal = () => {
    setIsEmployeeModalVisible(false);
    setSelectedEmployeeRowData(null);
  };

  // const LocationAnalysis = [
  //   {
  //     title: 'Location',
  //     dataIndex: 'location',
  //     key: 'location',
  //     render: (text, record) => {
  //       setLocation(record.location); // Call setLocation with the current record's location
  //       return text; // Return the text to display in the table cell
  //     },
  //   },
  //   {
  //     title: 'Billboard',
  //     dataIndex: 'mediaTypes',
  //     key: 'Billboard',
  //     render: (mediaTypes) => mediaTypes.find(type => type.hasOwnProperty('Billboard'))?.Billboard || 0,
  //   },
  //   {
  //     title: 'Gantry',
  //     dataIndex: 'mediaTypes',
  //     key: 'Gantry',
  //     render: (mediaTypes) => mediaTypes.find(type => type.hasOwnProperty('Gantry'))?.Gantry || 0,
  //   },
  //   {
  //     title: 'Cantilever',
  //     dataIndex: 'mediaTypes',
  //     key: 'Cantilever',
  //     render: (mediaTypes) => mediaTypes.find(type => type.hasOwnProperty('Cantilever'))?.Cantilever || 0,
  //   },
  //   {
  //     title: 'Hoarding',
  //     dataIndex: 'mediaTypes',
  //     key: 'Hoarding',
  //     render: (mediaTypes) => mediaTypes.find(type => type.hasOwnProperty('Hoarding'))?.Hoarding || 0,
  //   },
  //   {
  //     title: 'Kiosk',
  //     dataIndex: 'mediaTypes',
  //     key: 'Kiosk',
  //     render: (mediaTypes) => mediaTypes.find(type => type.hasOwnProperty('Kiosk'))?.Kiosk || 0,
  //   },
  //   {
  //     title: 'Unipole',
  //     dataIndex: 'mediaTypes',
  //     key: 'Unipole',
  //     render: (mediaTypes) => mediaTypes.find(type => type.hasOwnProperty('Unipole'))?.Unipole || 0,
  //   },
  //   {
  //     title: 'Top Client',
  //     dataIndex: 'topClient',
  //     key: 'topClient',
  //     render: (text, record) => {
  //       setTopClient(record.client); // Call setTopClient with the current record's client
  //       return record.client; // Return the client to display in the table cell
  //     },
  //   },
  //   {
  //     title: 'Occupancy Rate',
  //     dataIndex: 'occupancyRate',
  //     key: 'occupancyRate',
  //     render: (text, record) => {
  //       setoccupancy(record.occupancy); // Call setTopClient with the current record's client
  //       const formattedOccupancy = parseFloat(record.occupancy).toFixed(2); // Format the occupancy rate to two decimal places
  //       return formattedOccupancy; // Return the formatted occupancy rate to display in the table cell
  //     },
  //   },
  //   {
  //     title: 'Average Duration',
  //     dataIndex: 'averageDuration',
  //     key: 'averageDuration',
  //     render: (text, record) => {
  //       setAvgDuration(record.average)
  //       return record.average
  //     }
  //   },

  // ];
  // const LocationdataSource = [
  //   {
  //     key: '1',
  //     location: 'AEC',
  //     avgDuration: [
  //       { Gantry: "10" },
  //       { Cantilever: "10" },
  //       { Hoarding: "10" },
  //       { Kiosk: "10" },
  //       { Unipole: "10" }
  //     ],
  //     topClient: "1938 SARKAR JEWELLERS",
  //     occupancyRate: "20%",
  //     averageDuration: "30 Days"
  //   },
  //   {
  //     key: '2',
  //     location: 'Bopal',
  //     avgDuration: [
  //       { Gantry: "10" },
  //       { Cantilever: "10" },
  //       { Hoarding: "10" },
  //       { Kiosk: "10" },
  //       { Unipole: "10" }
  //     ],
  //     topClient: "1938 SARKAR JEWELLERS",
  //     occupancyRate: "50%",
  //     averageDuration: "30 Days"
  //   },
  // ];

  //---------------- location table code end

  //---------------- OccupancyAnalysis table code
  const OccupancyAnalysis = [
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Jan",
      dataIndex: "jan",
      key: "jan",
    },
    {
      title: "Feb",
      dataIndex: "feb",
      key: "feb",
    },
    {
      title: "Mar",
      key: "mar",
      dataIndex: "mar",
    },
    {
      title: "Kiosk",
      key: "kiosk",
      dataIndex: "Kiosk",
    },
    {
      title: "Apr",
      key: "apr",
      dataIndex: "apr",
    },
    {
      title: "May",
      key: "may",
      dataIndex: "may",
    },
    {
      title: "Jun",
      key: "jun",
      dataIndex: "jun",
    },
  ];

  const handleSearch = (value) => {
    setSearchValue(value);

    if (value) {
      const filteredData = salesData
        .filter((item) =>
          item.salesPerson.toLowerCase().includes(value.toLowerCase())
        )
        .map((item) => ({
          ...item,
          TotalSales: new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(item.TotalSales),
        }));

      setFilteredSalesData(filteredData);
      console.log("Filtered Data", filteredData);

      const options = filteredData.map((item) => ({ value: item.salesPerson }));
      setSearchOptions(options);
    } else {
      // Reset to all data when search is cleared, and format the TotalSales
      const resetData = salesData.map((item) => ({
        ...item,
        TotalSales: new Intl.NumberFormat("en-IN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(item.TotalSales),
      }));

      setFilteredSalesData(resetData);
      setSearchOptions([]);
    }
  };

  useEffect(() => {
    const formattedSalesData = salesData.map((item) => {
      return {
        ...item,
        TotalSales: new Intl.NumberFormat("en-IN", {
          minimumFractionDigits: 0, // Adjust the number of decimal places as needed
          maximumFractionDigits: 0, // Adjust the number of decimal places as needed
        }).format(item.TotalSales),
      };
    });
    // Set the initial state with all data
    setFilteredSalesData(formattedSalesData);
    console.log("FilterData", salesData);
  }, [salesData]);

  const handleSelect = (value) => {
    const filteredData = salesData.filter((item) => item.salesPerson === value);
    setFilteredSalesData(filteredData);
  };
  //---------------- ClientwiseRateAnalysis table code

  const ClientwiseRateAnalysis = [
    {
      title: "Clients",
      dataIndex: "clients",
      key: "clients",
    },
    {
      title: "Average Discount",
      dataIndex: "averageDiscount",
      key: "averageDiscount",
    },
    {
      title: "Total Booked",
      dataIndex: "totalBooked",
      key: "totalBooked",
    },
    {
      title: "FOC Inventories",
      key: "fOCInventories",
      dataIndex: "mar",
    },
    {
      title: "Avg Package Rate",
      key: "avgPackageRate",
      dataIndex: "avgPackageRate",
    },
    {
      title: "Under 5L",
      key: "under5L",
      dataIndex: "under5L",
    },
    {
      title: "Under 10L",
      key: "under10L",
      dataIndex: "under10L",
    },
    {
      title: "Under 20L",
      key: "under20L",
      dataIndex: "under20L",
    },
  ];
  //---------------- ClientwiseRateAnalysis table code End

  //---------------- EmployeeAnalysis table code
  // Refactored functions to accept fetchFunction as a parameter
  const setLastWeek = (fetchFunction) => {
    const start_date = moment().subtract(1, "weeks").startOf("week");
    const end_date = moment().subtract(1, "weeks").endOf("week");
    setDates([start_date, end_date]);
    fetchFunction(
      start_date.format("YYYY-MM-DD"),
      end_date.format("YYYY-MM-DD")
    );
  };

  const setLastMonth = (fetchFunction) => {
    const start_date = moment().subtract(1, "months").startOf("month");
    const end_date = moment().subtract(1, "months").endOf("month");
    setDates([start_date, end_date]);
    fetchFunction(
      start_date.format("YYYY-MM-DD"),
      end_date.format("YYYY-MM-DD")
    );
  };

  const setLastYear = (fetchFunction) => {
    const start_date = moment().subtract(1, "years").startOf("year");
    const end_date = moment().subtract(1, "years").endOf("year");
    setDates([start_date, end_date]);
    fetchFunction(
      start_date.format("YYYY-MM-DD"),
      end_date.format("YYYY-MM-DD")
    );
  };

  const handleSelectChange = (value) => {
    switch (value) {
      case "LastYear":
        setLastYear(fetchData);
        break;
      case "LastMonth":
        setLastMonth(fetchData);
        break;
      case "LastWeek":
        setLastWeek(fetchData);
        break;
      default:
        break;
    }
  };

  const handleSelectChangeClient = (value) => {
    switch (value) {
      case "LastYear":
        setLastYear(fetchDataClients);
        break;
      case "LastMonth":
        setLastMonth(fetchDataClients);
        break;
      case "LastWeek":
        setLastWeek(fetchDataClients);
        break;
      default:
        break;
    }
  };

  const handleRefreshEmployee = () => {
    setLastYear(fetchDataClients);
  };
  const EmployeeAnalysis = [
    {
      title: "Employee Name",
      dataIndex: "salesPerson",
      key: "salesPerson",
    },
    {
      title: "Total Sales",
      dataIndex: "TotalSales",
      key: "TotalSales",
    },
    // {
    //   title: 'Average Sales',
    //   dataIndex: 'AverageSales',
    //   key: 'AverageSales',
    // },
    {
      title: "Total Brands",
      dataIndex: "TotalClient",
      key: "TotalClient",
      render: (text, record) => (
        <>
          {Array.isArray(record.ClientsList) && record.ClientsList.length > 0
            ? record.ClientsList.length
            : "-"}
          {Array.isArray(record.ClientsList) &&
            record.ClientsList.length > 0 && (
              <button
                onClick={() =>
                  showRepeatedClients(record.ClientsList, "Total Brands")
                }
                style={{
                  border: "none",
                  marginLeft: "10px",
                  backgroundColor: "transparent",
                  color: "rgba(26, 115, 232, 1)",
                }}
              >
                View
              </button>
            )}
        </>
      ),
    },
    {
      title: "Repeat Brands",
      dataIndex: "RepeatedClients",
      key: "RepeatedClients",
      render: (text, record) => (
        <>
          {Array.isArray(record.RepeatedClientsList) &&
          record.RepeatedClientsList.length > 0
            ? record.RepeatedClientsList.length
            : "-"}
          {Array.isArray(record.RepeatedClientsList) &&
            record.RepeatedClientsList.length > 0 && (
              <button
                onClick={() =>
                  showRepeatedClients(
                    record.RepeatedClientsList,
                    "Repeat Brands"
                  )
                }
                style={{
                  border: "none",
                  marginLeft: "10px",
                  backgroundColor: "transparent",
                  color: "rgba(26, 115, 232, 1)",
                }}
              >
                View
              </button>
            )}
        </>
      ),
    },
    {
      title: "Frequent Area",
      dataIndex: "FrequentArea",
      key: "FrequentArea",
    },
    // {
    //   title: 'Top Industry',
    //   dataIndex: 'TopIndustry',
    //   key: 'TopIndustry',
    // },
  ];

  //-----------Clustor Demo Data start

  //-----------Clustor Demo Data end

  const menu = (
    <Menu style={{ padding: "10px 10px" }}>
      <Menu.Item>
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ width: "100%", display: "flex", justifyContent: "end" }}
        >
          <Button
            onClick={handleRefreshEmployee}
            style={{ display: "flex", alignItems: "center" }}
          >
            <IoIosRefresh />
          </Button>
        </div>
      </Menu.Item>
      <Menu.Item>
        <div onClick={(e) => e.stopPropagation()}>
          <AutoComplete
            style={{ width: "100%" }}
            value={searchValue}
            options={searchOptions}
            onSelect={handleSelect}
            onSearch={handleSearch}
            placeholder="Search"
          >
            <Input.Search />
          </AutoComplete>
        </div>
      </Menu.Item>
      <Menu.Item>
        <div onClick={(e) => e.stopPropagation()}>
          <Select
            onChange={handleSelectChange}
            placeholder="Select"
            style={{ width: "100%", marginRight: "5px" }}
          >
            <Option value="LastYear">Last Year</Option>
            <Option value="LastMonth">Last Month</Option>
            <Option value="LastWeek">Last Week</Option>
          </Select>
        </div>
      </Menu.Item>
      <Menu.Item>
        <div onClick={(e) => e.stopPropagation()}>
          <RangePicker onChange={handleDateChange} />
        </div>
      </Menu.Item>
    </Menu>
  );
  // ----------------------Tabs Table Data start
  const uniqueBrandSegments = Array.from(
    new Set(
      clientData?.flatMap((item) =>
        item.brands.map((brand) => brand.brandSegment)
      )
    )
  );
  const filteredClientData =
    selectedSegment !== null && selectedSegment?.length > 0
      ? clientData
          .filter((item) =>
            item.brands.some((brand) => brand.brandSegment === selectedSegment)
          )
          .sort((a, b) => {
            // Optionally sort by partyName or any other criteria
            return a.partyName.localeCompare(b.partyName);
          })
      : clientData;

  const handleSegmentChange = (value) => {
    setSelectedSegment(value);
  };
  const formatINR = (number) => {
    if (!number) return "0";

    let x = number.toString();

    // Split the number into integer and decimal parts
    let [integerPart, decimalPart] = x.split(".");

    // Format the integer part with commas
    let lastThree = integerPart.substring(integerPart.length - 3);
    let otherNumbers = integerPart.substring(0, integerPart.length - 3);

    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }

    let formattedNumber =
      otherNumbers.replace(/\B(?=(\d{2})+(?=\d{3})+(?!\d))/g, ",") + lastThree;

    // If there's a decimal part, add it back
    if (decimalPart) {
      formattedNumber += "." + decimalPart;
    }

    return formattedNumber;
  };

  // Usage example:
  if (access === false) {
    return <AuthorizationError />;
  }

  // Helper function to capitalize the first letter of a string
  const capitalizeEachWord = (str) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const items = [
    {
      key: "1",
      label: "Dashboard",
      children: (
        <>
          <BarChartComponent />
        </>
      ),
    },

    {
      key: "2",
      label: "Client Analysis",
      children: (
        <>
          <div className="LocationAnalysisContainerHeader">
            {/* <h4 style={{ fontSize: "20px", margin: "0px" }}>
              Client Analysis
            </h4> */}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <Button
                onClick={handleRefresh}
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "0px 5px",
                }}
              >
                <IoIosRefresh />
              </Button>
              <Select
                onChange={handleSelectChangeClient}
                placeholder="Select"
                style={{ width: "110px" }}
              >
                <Option value="LastYear">Last Year</Option>
                <Option value="LastMonth">Last Month</Option>
                <Option value="LastWeek">Last Week</Option>
              </Select>
              <Select
                style={{ margin: "0px 5px", width: "150px" }}
                placeholder="Select Industry"
                allowClear
                // mode="multiple"
                onChange={handleSegmentChange}
              >
                {uniqueBrandSegments
                  .sort((a, b) => a.localeCompare(b))
                  .map((segment, index) => (
                    <Option key={index} value={segment}>
                      {segment}
                    </Option>
                  ))}
              </Select>
              {/* <Switch
                checked={switchStates['1']}
                onChange={(checked) => onChange('1', checked)}
                checkedChildren="Direct Clients"
                unCheckedChildren="Agencies Clients"
              /> */}
            </div>
            {/* Include a switch here if needed */}
          </div>
          {/* <Table columns={ClientwiseRateAnalysis} /> */}
          <div className="DynamicAccordionTable">
            <div className="TableHeader">
              <div className="TableHeaderCell">
                <div style={{ width: "150px" }}>Clients</div>
              </div>
              <div className="TableHeaderCell">Total Bookings</div>
              <div className="TableHeaderCell">Total Booked Days</div>
              <div className="TableHeaderCell">Total Sales</div>
              <div className="TableHeaderCell">Avg Discount</div>
              <div className="TableHeaderCell">Avg&nbsp;Package&nbsp;Rate</div>
              <div className="TableHeaderCell">Under 5L</div>
              <div className="TableHeaderCell">5-15L</div>
              <div className="TableHeaderCell">15L+</div>
            </div>
            <div id="ClusterDesign">
              <Collapse accordion>
                {filteredClientData && filteredClientData.length > 0 ? (
                  filteredClientData.map((item) => {
                    // Filter and sort brands by brandSegment within each item
                    const sortedBrands = selectedSegment
                      ? item.brands
                          .filter(
                            (brand) => brand.brandSegment === selectedSegment
                          )
                          .sort((a, b) =>
                            a.brandSegment.localeCompare(b.brandSegment)
                          )
                      : item.brands.sort((a, b) =>
                          a.brandSegment.localeCompare(b.brandSegment)
                        ); // Default sorting if no segment is selected

                    // Recalculate the counts based on the sortedBrands
                    const under5LCount = sortedBrands.filter(
                      (brand) => brand.totalSale < 500000
                    ).length;
                    const between5LAnd15LCount = sortedBrands.filter(
                      (brand) =>
                        brand.totalSale >= 500000 && brand.totalSale <= 1500000
                    ).length;
                    const above15LCount = sortedBrands.filter(
                      (brand) => brand.totalSale > 1500000
                    ).length;

                    // Recalculate totals based on the sortedBrands
                    const totalAvgDiscount =
                      sortedBrands.reduce(
                        (sum, brand) => sum + brand.avgDiscount,
                        0
                      ) / sortedBrands.length;
                    const totalCount = sortedBrands.reduce(
                      (sum, brand) => sum + brand.totalCount,
                      0
                    );
                    const totalBookedDays = sortedBrands.reduce(
                      (sum, brand) => sum + brand.totalBookedDays,
                      0
                    );
                    const totalSale = sortedBrands.reduce(
                      (sum, brand) => sum + brand.totalSale,
                      0
                    );
                    const avgSalePerBrand =
                      sortedBrands.length > 0
                        ? (totalSale / sortedBrands.length).toFixed(2)
                        : 0;

                    return (
                      <Panel
                        header={
                          <div className="TableBody">
                            <div className="TableRow">
                              <div
                                className="TableCell"
                                style={{ fontWeight: "600" }}
                              >
                                <div
                                  style={{ width: "150px", marginLeft: "10px" }}
                                >
                                  {capitalizeEachWord(item.partyName)}
                                </div>
                              </div>

                              <div className="TableCell">{totalCount}</div>
                              <div className="TableCell">{totalBookedDays}</div>
                              <div className="TableCell">
                                {new Intl.NumberFormat("en-IN", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }).format(totalSale)}
                              </div>
                              <div className="TableCell">
                                {new Intl.NumberFormat("en-IN", {
                                  minimumFractionDigits:
                                    totalAvgDiscount === 0 ? 0 : 2,
                                  maximumFractionDigits:
                                    totalAvgDiscount === 0 ? 0 : 2,
                                }).format(totalAvgDiscount)}
                              </div>

                              <div className="TableCell">
                                {new Intl.NumberFormat("en-IN", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }).format(avgSalePerBrand)}
                              </div>

                              <div className="TableCell">{under5LCount}</div>
                              <div className="TableCell">
                                {between5LAnd15LCount}
                              </div>
                              <div className="TableCell">{above15LCount}</div>
                            </div>
                          </div>
                        }
                        key={item.partyName} // Ensure unique key
                      >
                        <div className="TableBody">
                          {sortedBrands.map((brand, brandIndex) => {
                            // Determine the condition texts based on totalSale value
                            const below5L =
                              brand.totalSale < 500000 ? (
                                <MdOutlineDone />
                              ) : (
                                "-"
                              );
                            const between5LAnd15L =
                              brand.totalSale >= 500000 &&
                              brand.totalSale <= 1500000 ? (
                                <MdOutlineDone />
                              ) : (
                                "-"
                              );
                            const above15L =
                              brand.totalSale > 1500000 ? (
                                <MdOutlineDone />
                              ) : (
                                "-"
                              );

                            return (
                              <div
                                key={`${brand.brandName}-${brandIndex}`}
                                className="TableRow"
                              >
                                <div
                                  className="TableCell"
                                  style={{ fontWeight: "600" }}
                                >
                                  <div style={{ width: "150px" }}>
                                    {capitalizeEachWord(brand.brandName)}(
                                    {brand.brandSegment})
                                  </div>{" "}
                                </div>
                                <div className="TableCell">
                                  {brand.totalCount}
                                </div>
                                <div className="TableCell">
                                  {brand.totalBookedDays}
                                </div>
                                <div className="TableCell">
                                  {new Intl.NumberFormat("en-IN", {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }).format(brand.totalSale)}
                                </div>
                                <div className="TableCell">
                                  {new Intl.NumberFormat("en-IN", {
                                    minimumFractionDigits:
                                      brand.avgDiscount === 0 ? 0 : 2,
                                    maximumFractionDigits:
                                      brand.avgDiscount === 0 ? 0 : 2,
                                  }).format(brand.avgDiscount)}
                                </div>
                                <div className="TableCell">-</div>
                                <div className="TableCell">{below5L}</div>
                                <div className="TableCell">
                                  {between5LAnd15L}
                                </div>
                                <div className="TableCell">{above15L}</div>
                              </div>
                            );
                          })}
                        </div>
                      </Panel>
                    );
                  })
                ) : (
                  <div
                    style={{
                      minHeight: "40vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    No data found.
                  </div>
                )}
              </Collapse>
            </div>
          </div>
        </>
      ),
    },
    {
      key: "3",
      label: "Employee Analysis",
      children: (
        <>
          <div className="LocationAnalysisContainerHeader">
            {/* <h4 style={{ fontSize: "20px", margin: "0px" }}>
              Employee Analysis
            </h4> */}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                maxWidth: "500px",
                overflow: "auto",
              }}
            >
              {/* <AutoComplete
                style={{ width: "200px", marginLeft: "10px" }}
                value={searchValue}
                options={searchOptions}
                onSelect={handleSelect}
                onSearch={handleSearch}
                placeholder="Search Employee"
              >
                <Input.Search />
              </AutoComplete>
              <Select onSelect={handleSelectChange} placeholder="Select Option" style={{ width: 130,margin:"0px 5px" }}>
                <Option value="LastYear">Last Year</Option>
                <Option value="LastMonth">Last Month</Option>
                <Option value="LastWeek">Last Week</Option>
              </Select> */}
              {/* <div style={{ margin: "5px" }}>
                <Dropdown overlay={menu} placement="bottomRight" arrow trigger={['click']} >
                  <Button><FaFilter /></Button>
                </Dropdown>
              </div> */}
              <Dropdown
                overlay={menu}
                placement="bottomRight"
                arrow
                trigger={["click"]}
              >
                <Button>
                  <FaFilter />
                </Button>
              </Dropdown>
            </div>
            {/* Include a switch here if needed */}
          </div>
          <div id="EmployeeTable">
            <Table
              columns={EmployeeAnalysis}
              dataSource={filteredSalesData}
              rowKey="salesPerson"
              pagination={{
                pageSize: 20, // Number of records to show per page
                showSizeChanger: true, // Optionally show a size changer dropdown
                pageSizeOptions: ["10", "20", "50", "100"], // Optional page size options
              }}
            />
          </div>
          <Modal
            visible={isModalVisibleEmployee}
            onCancel={handleCancel}
            footer={null}
          >
            {Array.isArray(repeatedClients) && repeatedClients.length > 0 ? (
              <ul>
                {repeatedClients.map((client, index) => (
                  <li key={index} style={{ listStyle: "none" }}>
                    {capitalizeEachWord(client)}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No clients to display.</p>
            )}
          </Modal>
          {/* <Table
            columns={EmployeeAnalysis}
            // dataSource={EmployeeAnalysisDatasource}
            onRow={(record) => ({
              onClick: () => handleEmployeeRowClick(record),
            })}
          /> */}
          {/* <Modal
            title={`Selected Employee: ${selectedEmployeeRowData ? selectedEmployeeRowData.employeeName : ''}`}
            visible={isEmployeeModalVisible}
            onCancel={handleCloseEmployeeModal}
            onOk={handleCloseEmployeeModal}
            footer={null}
          >
            {selectedEmployeeRowData && (
              <>
                {EmployeeAnalysisDatasource.filter(item => item.employeeName === selectedEmployeeRowData.employeeName).map((item, index) => (
                  <div className="ModalValues">
                    <div>
                      <span><b>Employe Name:</b></span><p> {selectedEmployeeRowData.employeeName}</p>
                    </div>
                    <div>
                      <span><b>Total Sales:</b></span><p> {selectedEmployeeRowData.totalSales}</p>
                    </div>
                    <div>
                      <span><b>Total Clients:</b></span><p> {selectedEmployeeRowData.totalClients}</p>
                    </div>
                    <div>
                      <span><b>Repeated Clients:</b></span> <p>{selectedEmployeeRowData.repeatedClients}</p>
                    </div>
                    <div>
                      <span><b>Frequency of Sales:</b></span> <p>{selectedEmployeeRowData.frequencyofSales}</p>
                    </div>
                    <div>
                      <span><b>Frequency of Locations:</b></span> <p>{selectedEmployeeRowData.frequentLocations}</p>
                    </div>
                  </div>
                ))}

              </>
            )}
          </Modal> */}
        </>
      ),
    },
    {
      key: "4",
      label: "Occupancy  Analysis",
      children: (
        <>
          <div className="LocationAnalysisContainerHeader">
            {/* <h4 style={{ fontSize: '20px', margin: '0px' }}>Occupancy Analysis</h4> */}
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Select
                placeholder="Select a segment"
                mode="multiple"
                style={{
                  width: 150,
                  margin: "0px 5px",
                  maxHeight: "50px",
                  overflow: "auto",
                }}
                onChange={(value) => {
                  onSelectChange(value);
                }}
              >
                {segments.map((segment, index) => (
                  <Option key={index} value={segment}>
                    {segment}
                  </Option>
                ))}
              </Select>
              <div>
                <Input
                  value={dateRangeString}
                  disabled={true}
                  style={{ width: "50px" }}
                />
              </div>
              <RangePicker
                style={{ width: "200px" }}
                value={selectedoccupancydates}
                onChange={handleOccupancyDateChange}
                format="YYYY-MM-DD"
                disabledDate={disableFutureDates}
              />
            </div>
          </div>
          <div id="ClusterDesign">
            <div className="DynamicAccordionTable">
              <div className="TableHeader">
                <div className="TableHeaderCell">Location</div>
                <div className="TableHeaderCell">Avg Rate (in ₹)</div>
                <div className="TableHeaderCell">Avg Duration (in days)</div>
                <div className="TableHeaderCell">Avg Occupancy (in %)</div>
                <div className="TableHeaderCell">Top Segment</div>
              </div>

              {occupancyData.map((occ) => {
                let avgRate = 0;
                let avgDuration = 0;
                let avgocuupancy = 0;
                occ.inventories.map((inv) => {
                  avgRate += inv.avg_rate;
                  avgDuration += inv.avg_duration;
                  avgocuupancy += inv.avg_occupancy;
                });
                avgRate = (avgRate / occ.inventories.length).toFixed(2);
                avgDuration = (avgDuration / occ.inventories.length).toFixed(2);
                avgocuupancy = (avgocuupancy / occ.inventories.length).toFixed(
                  2
                );

                return (
                  <Collapse accordion>
                    <Panel
                      header={
                        <div className="TableBody">
                          <div className="TableRow">
                            <div
                              className="TableCell"
                              style={{ fontWeight: "600" }}
                            >
                              {occ.areaName}
                            </div>
                            <div className="TableCell">
                              {formatIndianNumber(avgRate)}
                            </div>
                            <div className="TableCell">{avgDuration}</div>
                            <div className="TableCell">{avgocuupancy}</div>
                            <div className="TableCell">{occ.segment}</div>
                          </div>
                        </div>
                      }
                    >
                      {occ.inventories.map((inv) => (
                        <div className="TableBody">
                          <div className="TableRow">
                            <div className="TableCell">{inv.locationName}</div>
                            <div className="TableCell">
                              {formatIndianNumber(inv.avg_rate)}
                            </div>
                            <div className="TableCell">
                              {inv.avg_duration.toFixed(2)}
                            </div>
                            <div className="TableCell">{inv.avg_occupancy}</div>
                            <div className="TableCell">{inv.top_segment}</div>
                          </div>
                        </div>
                      ))}
                    </Panel>
                  </Collapse>
                );
              })}
            </div>
          </div>
        </>
      ),
    },
    // {
    //   key: '5',
    //   label: 'Vendor Analysis',
    //   children: (
    //     <>
    //     </>
    //   ),
    // },
  ];

  // ----------------------Tabs Table Data start End

  return (
    <>
      <div style={{ minHeight: "90vh", overflow: "auto", padding: "0px 24px" }}>
        <div className="YellospotDashboardCards">
          <div
            onClick={() => handleContainerClick("sales")}
            style={{ cursor: "pointer" }}
          >
            <p>Total Sales</p>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              <img style={{ width: "13px" }} src={Ruppes} alt="" />
              &nbsp;
              {totalSales && typeof totalSales.total_sales === "number"
                ? Math.round(totalSales.total_sales).toLocaleString("en-IN")
                : "Loading..."}
            </h3>
            <img
              src={greenL}
              alt=""
              className="SetImage"
              style={{
                backgroundColor: "rgb(74 217 145 / 25%)",
                padding: "8px",
                borderRadius: "10px",
              }}
            />
          </div>
          <div
            onClick={() => handleContainerClick("profit")}
            style={{ cursor: "pointer" }}
          >
            <p>Total Profit</p>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              <img src={Ruppes} alt="" style={{ width: "13px" }} />
              &nbsp;
              {profit && typeof profit.total_profit === "number"
                ? Math.round(profit.total_profit).toLocaleString("en-IN")
                : "Loading..."}
            </h3>
            <img
              src={box}
              alt=""
              className="SetImage"
              style={{
                backgroundColor: "rgb(254 197 61 / 25%)",
                padding: "8px",
                borderRadius: "10px",
              }}
            />
          </div>
          <div
            onClick={() => handleContainerClick("proposals")}
            style={{ cursor: "pointer" }}
          >
            <p>Total Proposal Made</p>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              {proposals && typeof proposals.total_proposals === "number"
                ? proposals.total_proposals.toLocaleString("en-IN")
                : "Loading..."}
            </h3>
            <img
              src={TotalProposel}
              alt=""
              className="SetImage"
              style={{
                backgroundColor: "rgb(128 186 255 / 25%)",
                padding: "8px",
                borderRadius: "10px",
              }}
            />
          </div>
          <div
            onClick={() => handleContainerClick("bookings")}
            style={{ cursor: "pointer" }}
          >
            <p>Total Booking Converted</p>
            <h3 style={{ display: "flex", alignItems: "center" }}>
              {bookings && typeof bookings.total_bookings === "number"
                ? bookings.total_bookings.toLocaleString("en-IN")
                : "Loading..."}
            </h3>
            <img
              src={TotalBooking}
              alt=""
              className="SetImage"
              style={{
                backgroundColor: "rgb(130 128 255 / 24%)",
                padding: "8px",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
        {/* <GraphComponent /> */}
        {/* <br /> */}
        <div className="LocationAnalysisContainer">
          <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={handleTabChange}
            activeKey={activeTab}
          />{" "}
        </div>
        <br />
        <br />
        {/* <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "20px" }}>
          <div style={{ height: "70px", display: "flex", alignItems: "center" }}>
            <h4>Industry Analysis</h4>
          </div>
          <MonthlyCategoryChart data={data} />
        </div> */}
        <br />
        <br />
        <Modal
          title="Details"
          visible={isCommonModalVisible}
          onCancel={handleCancel}
          footer={null}
        >
          {typeof modalData.new_sales === "number" && (
            <p>
              <strong>New Sales:</strong>{" "}
              {formatINR(Math.round(modalData.new_sales))}
            </p>
          )}
          {typeof modalData.old_sales === "number" && (
            <p>
              <strong>Old Sales:</strong>{" "}
              {formatINR(Math.round(modalData.old_sales))}
            </p>
          )}
          {typeof modalData.total_sales === "number" && (
            <p>
              <strong>Total Sales:</strong>{" "}
              {formatINR(Math.round(modalData.total_sales))}
            </p>
          )}
          {typeof modalData.new_profit === "number" && (
            <p>
              <strong>New Profit:</strong>{" "}
              {formatINR(Math.round(modalData.new_profit))}
            </p>
          )}
          {typeof modalData.old_profit === "number" && (
            <p>
              <strong>Old Profit:</strong>{" "}
              {formatINR(Math.round(modalData.old_profit))}
            </p>
          )}
          {typeof modalData.total_profit === "number" && (
            <p>
              <strong>Total Profit:</strong>{" "}
              {formatINR(Math.round(modalData.total_profit))}
            </p>
          )}
          {typeof modalData.accepted_proposals === "number" && (
            <p>
              <strong>Accepted Proposals:</strong>{" "}
              {formatINR(modalData.accepted_proposals)}
            </p>
          )}
          {typeof modalData.pending_proposals === "number" && (
            <p>
              <strong>Pending Proposals:</strong>{" "}
              {formatINR(modalData.pending_proposals)}
            </p>
          )}
          {typeof modalData.total_proposals === "number" && (
            <p>
              <strong>Total Proposals:</strong>{" "}
              {formatINR(modalData.total_proposals)}
            </p>
          )}
          {typeof modalData.converted_booking === "number" && (
            <p>
              <strong>Converted Booking:</strong>{" "}
              {formatINR(modalData.converted_booking)}
            </p>
          )}
          {typeof modalData.direct_booking === "number" && (
            <p>
              <strong>Direct Booking:</strong>{" "}
              {formatINR(modalData.direct_booking)}
            </p>
          )}
          {typeof modalData.total_bookings === "number" && (
            <p>
              <strong>Total Bookings:</strong>{" "}
              {formatINR(modalData.total_bookings)}
            </p>
          )}
        </Modal>
      </div>
    </>
  );
};
export default Analysis;
